module.exports = __webpack_public_path__ + "img/471ef7cbe3a373d87c8f96500ddf1cb1.cbb3338b.png";